"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Button_1 = __importDefault(require("../Button"));
var Icon_1 = __importDefault(require("../Icon"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"], ["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var Title = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  color: ", ";\n  font-size: ", ";\n  font-weight: bold;\n"], ["\n  text-align: center;\n  color: ", ";\n  font-size: ", ";\n  font-weight: bold;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.inactiveColor;
}, polished_1.rem(32));
var Spacer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: ", ";\n"], ["\n  height: ", ";\n"])), polished_1.rem(20));
var C = function (_a) {
    var className = _a.className, icon = _a.icon, title = _a.title, theme = _a.theme, onClickAction = _a.onClickAction, actionLabel = _a.actionLabel;
    return (React.createElement(Wrapper, { className: className },
        icon && React.createElement(Icon_1.default, { name: icon, size: "xxl", color: theme.inactiveColor }),
        icon && title && React.createElement(Spacer, null),
        title && React.createElement(Title, null, title),
        onClickAction && actionLabel && (React.createElement(React.Fragment, null,
            React.createElement(Spacer, null),
            React.createElement(Button_1.default, { primary: true, onClick: onClickAction }, actionLabel)))));
};
exports.default = styled_components_1.withTheme(C);
var templateObject_1, templateObject_2, templateObject_3;
